import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { useEditor } from 'react-pagebuilder/hooks/useEditor'
import { BrandsSection as Original } from 'components/organisms'
import { BrandsSectionSettings, BrandsSectionFloatingSettings } from './BrandsSectionSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import {
  ctaDefaultProps,
  ctaItemParams,
} from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/CtaToolbarSection'
import { getTextEditor } from '../TextEditor'
import {
  layoutDefaultProps,
  layoutItemParams,
} from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/LayoutToolbarSection'
import { useBrandsQuery } from '@gql/graphql'

export const defaultProps = {
  ...ctaDefaultProps(''),
  ...layoutDefaultProps('lg'),
  theme: 'white',
}

export const brandListItemParams = (enabled, id, blockProps, children) => ({
  ...ctaItemParams(blockProps, enabled),
  ...layoutItemParams(blockProps),
  pk: id,
  name: getTextEditor(children?.[0], enabled),
  description: getTextEditor(children?.[1], enabled),
})

export const dynamicProps = []

export const BrandsSection: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }

    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    const { enabled } = useEditor(
      (state) => ({
        enabled: state.options.enabled,
      }),
      props
    )

    const { data } = useBrandsQuery({})

    return (
      <div ref={(ref) => props.retRef(ref)} className={`block-brand-list ${props.className}`}>
        <Original
          brands={data?.brands}
          item={brandListItemParams(enabled, id, blockProps, children)}
          theme={blockProps.theme}
          editMode={enabled}
        />
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

BrandsSection.craft = withCraft({
  name: 'BrandsSection',
  defaultProps: defaultProps,
  settings: BrandsSectionSettings,
  floatingSettings: BrandsSectionFloatingSettings,
})
